import { Staff_LIST, Staff_DETAIL,LOADING,NOT_FOUND } from "../action/type";

const initialState = {
  list: [{}],
  loading:false,
  not_found:false
};
const staff = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading:true ,not_found:false};
    case NOT_FOUND:
      return { ...state, loading:false,not_found: true };
    case Staff_LIST:
      return { ...state, list: action.payload ,loading:false ,not_found:false};
    case Staff_DETAIL:
      return { ...state, list: action.payload ,loading:false ,not_found:false};
    default:
      return state;
  }
};

export default staff;
